export const TabNavEvent = {
  ADMIN: 'adminInView',
  COMMS_HISTORY: 'userCommsHistoryInView',
  CONTACT_NOTES: 'contactNotesInView',
  DEVICE_DATA: 'deviceDataInView',
  DEVICE_EVENTS: 'deviceEventsInView',
  ENG_BOOKING: 'engineerBookingInView',
  LEAK_FREE: 'leakFreeInView'
}
